import { bl_aat_engagement_fye_hdr_RowClass } from '../../../dbschema/bl_aat_engagement_fye_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class EngagementFYEHdrContainerModel extends BaseContainerModel {
    bl_aat_engagement_fye_hdr: bl_aat_engagement_fye_hdr_RowClass = new bl_aat_engagement_fye_hdr_RowClass();
}